import React from "react";
import { Clock, AlertTriangle, CheckCircle } from "lucide-react";
import '../../styles/deadlinebadge.css'

export default function DeadlineBadge({ dateString }) {
  if (!dateString) return null;

  const dueDate = new Date(dateString);
  const now = new Date();
  const diffMs = dueDate - now;
  const diffHrs = diffMs / (1000 * 60 * 60);
  const diffDays = diffHrs / 24;

  let status = "";
  let bg = "";
  let Icon = null;
  let text = "";

  if (diffHrs < 0) {
    status = "overdue";
    bg = "overdue";
    Icon = Clock;
    text = "Overdue";
  } else if (diffHrs <= 24) {
    status = "soon";
    bg = "soon";
    Icon = AlertTriangle;
    const hoursLeft = Math.floor(diffHrs);
    text = ` At Risk - ${hoursLeft} hour${hoursLeft !== 1 ? "s" : ""}`;
  } else if (diffHrs <= 48) {
    status = "upcoming";
    bg = "upcoming";
    Icon = CheckCircle;
    const hoursLeft = Math.floor(diffHrs);
    text = ` On Track -${hoursLeft} hour${hoursLeft !== 1 ? "s" : ""} left`;
  } else {
    status = "upcoming";
    bg = "upcoming";
    Icon = CheckCircle;
    const daysLeft = Math.floor(diffDays);
    text = `${daysLeft} day${daysLeft !== 1 ? "s" : ""} left`;
  }

  return (
    <div
      className={` ${bg}`}
      title={dueDate.toLocaleString()}
    >
      <Icon size={16} />
      <span>{text}</span>
    </div>
  );
}
